document.addEventListener('DOMContentLoaded', function() {

  // ─── Mobile Menu Toggle ───────────────────────────────────────────────────
  var mobileMenuBtn = document.getElementById('mobileMenuBtn');
  var mobileMenu = document.getElementById('mobileMenu');

  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = mobileMenu.style.display === 'block';
      mobileMenu.style.display = isOpen ? 'none' : 'block';
      mobileMenuBtn.innerHTML = isOpen
        ? '<i class="fas fa-bars"></i>'
        : '<i class="fas fa-times"></i>';
      mobileMenuBtn.setAttribute('aria-expanded', String(!isOpen));
    });

    document.addEventListener('click', function(e) {
      if (mobileMenu.style.display === 'block' && !mobileMenu.contains(e.target) && e.target !== mobileMenuBtn) {
        mobileMenu.style.display = 'none';
        mobileMenuBtn.innerHTML = '<i class="fas fa-bars"></i>';
        mobileMenuBtn.setAttribute('aria-expanded', 'false');
      }
    });

    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.style.display = 'none';
        mobileMenuBtn.innerHTML = '<i class="fas fa-bars"></i>';
        mobileMenuBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ─── Floating cart button ─────────────────────────────────────────────────
  // layout/theme.liquid renders it already visible whenever the cart has items,
  // so a refresh never loses it. JS only keeps the count and label in step.
  //
  // Dismissing it hides it for THIS page view only. It used to be remembered in
  // sessionStorage, which meant one dismissal silently suppressed the button on
  // every later page and after every reload — it read as the button vanishing
  // on its own. A reload is a fresh look at the page, so the button comes back.
  var toast = document.getElementById('cart-toast');
  var toastCount = document.getElementById('cart-toast-count');
  var toastText = document.getElementById('cart-toast-text');
  var toastSub = document.getElementById('cart-toast-sub');
  var fabDismissed = false;

  function paintCartFab(itemCount, productTitle) {
    if (!toast) return;
    toast.dataset.count = itemCount;
    if (itemCount < 1) { toast.classList.remove('show'); return; }
    if (toastCount) toastCount.textContent = itemCount;
    if (toastText) toastText.textContent = productTitle ? 'Added to cart' : 'View cart';
    if (toastSub) {
      toastSub.textContent = productTitle
        ? productTitle.substring(0, 32) + (productTitle.length > 32 ? '\u2026' : '')
        : itemCount + ' item' + (itemCount !== 1 ? 's' : '') + ' in cart';
    }
    // Adding something is a fresh intent, so it overrides a dismissal.
    if (productTitle) fabDismissed = false;
    if (toast.dataset.onCartPage !== 'true' && !fabDismissed) toast.classList.add('show');
  }

  function showCartToast(itemCount, productTitle) {
    paintCartFab(itemCount, productTitle || '');
  }

  if (toast) {
    toast.addEventListener('click', function(e) {
      if (e.target.closest('#cart-toast-close')) {
        toast.classList.remove('show');
        fabDismissed = true;
        return;
      }
      window.location.href = '/cart';
    });

    // Coming back via the back button serves the page from the bfcache, which
    // skips DOMContentLoaded entirely. Without this the button keeps whatever
    // state it had when the shopper left, including a dismissal.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      fabDismissed = false;
      if (toast.dataset.onCartPage !== 'true' && Number(toast.dataset.count) > 0) {
        toast.classList.add('show');
      }
    });
  }

  // Update header cart count badge
  function updateHeaderCartCount(count) {
    var badge = document.querySelector('.cart-count');
    if (count > 0) {
      if (!badge) {
        var cartIcon = document.querySelector('a[href="/cart"] .fa-shopping-bag');
        if (cartIcon) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          cartIcon.parentElement.appendChild(badge);
        }
      }
      if (badge) badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  // ─── AJAX Add to Cart ────────────────────────────────────────────────────
  // Intercept all add-to-cart forms (product cards + product page)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.matches('form[action="/cart/add"]')) return;

    // Check if this has a Buy Now intent flag (set by JS below)
    if (form.dataset.buyNow === 'true') return; // let it submit normally

    e.preventDefault();

    var formData = new FormData(form);
    var submitBtn = form.querySelector('button[type="submit"]');
    var originalHTML = submitBtn ? submitBtn.innerHTML : '';

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(function(res) { return res.json(); })
    .then(function(item) {
      // Get current cart count
      return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        updateHeaderCartCount(cart.item_count);
        showCartToast(cart.item_count, item.title);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = '<i class="fas fa-check"></i> Added!';
          setTimeout(function() { submitBtn.innerHTML = originalHTML; }, 2000);
        }
      });
    })
    .catch(function(err) {
      console.error('Cart error:', err);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalHTML;
      }
    });
  });

  // ─── Checkout hand-off ─────────────────────────────────────────────────────
  // Razorpay Magic Checkout (app embed) opens its popup when a checkout button
  // matching button[type="button"][name="checkout"] is clicked. We click a hidden
  // one; if Magic isn't on the page (embed off / blocked), fall back to /checkout.
  function goToCheckout() {
    var trigger = document.getElementById('bbs-checkout-trigger');
    if (!trigger) {
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.name = 'checkout';
      trigger.id = 'bbs-checkout-trigger';
      trigger.setAttribute('aria-hidden', 'true');
      trigger.tabIndex = -1;
      trigger.style.display = 'none';
      document.body.appendChild(trigger);
    }
    var magicPresent = !!document.querySelector('script[src*="magic-plugins.razorpay.com"]');
    if (!magicPresent) { window.location.href = '/checkout'; return; }
    trigger.click();
    // Safety net ONLY for when Magic never reacts (script blocked / failed).
    // As soon as any Razorpay element shows up (loader, backdrop, popup) we stand
    // down for good — Razorpay owns the flow from there, including its own
    // fallback to Shopify checkout.
    var seen = false;
    var isRzp = function () {
      return !!document.querySelector('.razorpay-backdrop, .razorpay-sopc-container, .razorpay-container, [class*="razorpay"], [id*="razorpay"], iframe[src*="razorpay"]');
    };
    var obs = new MutationObserver(function () { if (isRzp()) { seen = true; obs.disconnect(); } });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
      if (!seen && !isRzp() && document.visibilityState === 'visible') window.location.href = '/checkout';
    }, 8000);
  }
  window.bbsGoToCheckout = goToCheckout;

  // ─── PDP Buy Now — add the selected variant + quantity, then checkout ─────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pdp-buy-now]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form');
    if (!form) { goToCheckout(); return; }
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) { if (!res.ok) throw new Error('add'); return res.json(); })
      .then(function () { btn.disabled = false; btn.innerHTML = original; goToCheckout(); })
      .catch(function () {
        btn.disabled = false; btn.innerHTML = original;
        alert('Sorry, this item could not be added. Please try again.');
      });
  });

  // ─── Buy Now — add to cart then go to checkout ───────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.buy-now-btn');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.dataset.variantId;
    var qty = btn.dataset.qty || 1;
    if (!variantId) {
      // Fallback: navigate to product URL
      window.location.href = btn.href || '/collections/all';
      return;
    }

    var origHtml = btn.innerHTML;
    btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
    btn.style.pointerEvents = 'none';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.innerHTML = origHtml;
      btn.style.pointerEvents = '';
      goToCheckout();
    })
    .catch(function() {
      window.location.href = '/checkout';
    });
  });

});

/* ─────────────────────────────────────────────────────────────────────────────
   Offer countdown timers
   Drives every [data-offer-timer] on the page from a single interval.
   The deadline comes from the server (a product metafield), so it is the same
   for every visitor and cannot be reset by reloading.
   ───────────────────────────────────────────────────────────────────────────── */
(function () {
  var timers = [];
  var ticking = null;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function paint(el, secondsLeft) {
    var d = Math.floor(secondsLeft / 86400);
    var h = Math.floor((secondsLeft % 86400) / 3600);
    var m = Math.floor((secondsLeft % 3600) / 60);
    var s = Math.floor(secondsLeft % 60);

    if (el.getAttribute('data-format') === 'colon') {
      var clock = el.querySelector('[data-clock]');
      if (clock) clock.textContent = pad(d) + ':' + pad(h) + ':' + pad(m) + ':' + pad(s);
      return;
    }

    var dayEl = el.querySelector('[data-days]');
    if (dayEl) {
      if (d > 0) {
        dayEl.hidden = false;
        dayEl.querySelector('b').textContent = pad(d);
      } else {
        dayEl.hidden = true;
      }
    }
    var map = { '[data-hours]': h, '[data-minutes]': m, '[data-seconds]': s };
    Object.keys(map).forEach(function (sel) {
      var node = el.querySelector(sel);
      if (node) node.querySelector('b').textContent = pad(map[sel]);
    });
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    var alive = [];

    timers.forEach(function (el) {
      var ends = parseInt(el.getAttribute('data-ends'), 10);
      if (!ends || isNaN(ends)) return;

      var left = ends - now;
      if (left <= 0) {
        // Offer is over. Remove it rather than showing zeros.
        el.remove();
        return;
      }
      paint(el, left);
      alive.push(el);
    });

    timers = alive;
    if (!timers.length && ticking) {
      clearInterval(ticking);
      ticking = null;
    }
  }

  function init(root) {
    var found = (root || document).querySelectorAll('[data-offer-timer]');
    if (!found.length) return;

    Array.prototype.forEach.call(found, function (el) {
      if (timers.indexOf(el) === -1) timers.push(el);
    });

    tick();
    if (!ticking && timers.length) ticking = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Shopify theme editor: re-scan when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
